import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Drawer,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Theme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import React, { useEffect } from "react";
import { getPublicImagePath } from "../App";
import { useHistory, useParams } from "react-router-dom";
import {toFistCharUpperCase} from "../utils/Formatter";
import ResponsiveDrawer from "../components/ClippedResponsiveDrawer";

import AdminEmailDL from "../components/admin/AdminEmailDL";
import AdminContracts from "../components/admin/AdminContracts";
import AdminBanks from "../components/admin/AdminBanks";
import AdminMaps from "../components/admin/AdminMaps";
import AdminBulkBrandFlow from "../components/admin/AdminBulkBrandFlow";
import AdminOptimization from "../components/admin/AdminOptimization";
import AdminMaterialReplacement from "../components/admin/AdminMaterialReplacement";
import AdminEquipmentMapping from "../components/admin/AdminEquipmentMapping";
import AdminEquipmentCapacity from "../components/admin/AdminEquipmentCapacity";
import AdminEquipmentMissing from "../components/admin/AdminEquipmentMissing";
import AdminSalesOfficeOperation from "../components/admin/AdminSalesOfficeOperation";
import AdminMaterialStrategic from "../components/admin/AdminMaterialStrategic";
import AdminBulkNotes from "../components/admin/AdminBulkNotes";
import AdminBulkSuspensions from "../components/admin/AdminBulkSuspensions";
import ComAdminLatestLogin from "../components/admin/ComAdminLatestLogin";

import AdminSystemConfig from "../components/admin/AdminSystemConfig";
import AdminBufferConfig from "../components/admin/AdminBufferConfig";
import AdminSeasonalityConfig from "../components/admin/AdminSeasonalityConfig";
import AdminSetPriority from "../components/admin/AdminSetPriority";

import SecAdminRoles from "../components/admin/SecAdminRoles";
import AdminAccessConfig from "../components/admin/AdminAccessConfig";
import SecAdminRoleMap from "../components/admin/SecAdminRolesMapping";
import SecAdminSalesOff from "../components/admin/SecAdminSalesOffice";
import SecAdminLatestLogin from "../components/admin/SecAdminLatestLogin";
import SecAdminAudit from "../components/admin/SecAdminAudit";

import BatchMonJobStatus from "../components/admin/BatchMonJobStatus";
import BatchMonJobHistory from "../components/admin/BatchMonJobHist";

import ISupDEX from "../components/admin/ISupDEX";
import ISupECA from "../components/admin/ISupECA";
import ISupHCEmailPDF from "../components/admin/ISupHCEmailPDF";
import ISupHCTicketStatus from "../components/admin/ISupHCTicketStatus";
import ISupPrioQueue from "../components/admin/ISupPrioQueue";
import Configurations from "../components/admin/Configurations";

import { checkForRoles } from "../utils/GetAuth";
import { useLocalStorage } from "../utils/LocalStorageHook";
import WarehouseLocation from "../components/admin/Warehouse";
import AdminAlertMessages from "../components/admin/AdminAlertMessages";
import ImageUtility from "../components/admin/ImageUtility";

import CloudSyncIcon from '@mui/icons-material/CloudSync';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import {
  ExpandMore,
  Tune,
  Security,
  VerifiedUser,
  NoteAdd,
  Email,
  Apartment,
  SupervisedUserCircle,
  ViewQuilt,
  Star,
  Queue,
  SportsCricket,
  FindReplace,
  Book,
  TimerOff,
  EmojiTransportation,
  DateRange,
  Settings,
  Public,
  ViewComfy,
  Traffic,
  History,
  ContactSupport,
  PictureAsPdf,
  MonitorHeart,
  Warehouse,
  Rule,
  Schema,
} from '@mui/icons-material';
import ImageIcon from '@mui/icons-material/Image';
import RouteIcon from '@mui/icons-material/Route';
import GradeIcon from '@mui/icons-material/Grade';
import PercentIcon from '@mui/icons-material/Percent';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import AdminRouteManagement from "src/components/admin/AdminRouteManagement";
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import AdminBulkSales from "src/components/admin/AdminBulkSales";
import ISupSapLog from "src/components/admin/ISupSapLog";
import MonitorIcon from '@mui/icons-material/Monitor';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Reconciliation from "src/components/admin/Reconciliation";
import AdminAccessMode from "src/components/AdminAccessMode";
import DescriptionIcon from "@mui/icons-material/Description";

import DEXRequeue from "src/components/DEX_Requeue";



const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    accordion: {
    },
    breadCrumbs: {
      paddingBottom: theme.spacing(2),
    },
    centerDiv: {
      textAlign: "center",
    },
    root: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    rootContainer: {
      [theme.breakpoints.down("md")]: {
        padding: 0,
        paddingTop: theme.spacing(1),
      },
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    chipActual: {
      marginTop: theme.spacing(2),
      marginRight: theme.spacing(1),
    },
    mapContainer: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    drawer: {
      width: drawerWidth,
      zIndex: theme.zIndex.appBar - 10,
      flexShrink: 0,
    },
    drawerPaper: {
      marginTop: 70, 
      zIndex: theme.zIndex.appBar - 9,
      width: drawerWidth,
    },
    drawerContainer: {
      zIndex: theme.zIndex.appBar - 8,
      overflow: 'auto',
    },
    drawerTitle:{
    },
    drawerNavLink:{
      width:drawerWidth-50,
    },
    drawerTab:{},
    content: {
      flexGrow: 1,
      marginLeft: drawerWidth,
      padding: theme.spacing(3),
    },
    image: {
      margin: 0,
      padding: theme.spacing(8),
      maxHeight: "40vh",
    },
    primary: {
      marginTop: theme.spacing(2),
    },
    paragraph: {
      padding: theme.spacing(1),
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    '&.css-cveggr-MuiListItemIcon-root':{
      marginLeft: '-10px',
    }
  })
);

const navigation:{
  title:string,
  icon?:any,
  defaultExpanded?:boolean
  roles:string[],
  subtabs: {
    subtitle:string,
    roles:string[],
    icon?:any,
    content:JSX.Element,
  }[]
}[] =  [
  {
    title: "CONA Support",
    roles:['cona_internal_dev'],
    defaultExpanded:false,
    subtabs:[
      {
        subtitle: "Priority Queue",
        roles:[],
        icon:<Rule/>,
        content: <ISupPrioQueue />,
      },
      {
        subtitle: "DEX Monitor",
        roles:[],
        icon:<SportsCricket/>,
        content: <ISupDEX />,
      },
      {
        subtitle: "HC PDF Emails",
        roles:[],
        icon:<PictureAsPdf />,
        content: <ISupHCEmailPDF />,
      },
      {
        subtitle: "HC Req Status",
        roles:[],
        icon:<MonitorHeart />,
        content: <ISupHCTicketStatus />,
      },
      {
        subtitle: "Admin Alert Messages",
        roles:[],
        icon:<AnnouncementIcon />,
        content: <AdminAlertMessages/>,
      },
      {
        subtitle: "Disable ECA",
        roles:[],
        icon:<ContactSupport/>,
        content: <ISupECA />,
      },
      {
        subtitle: "SAP Request Monitor",
        roles:[],
        icon:<MonitorIcon/>,
        content: <ISupSapLog />,
      },
      {
        subtitle: "Reconciliation",
        roles:[],
        icon: <SyncAltIcon/>,
        content: <Reconciliation />
      },
      
      {
        subtitle: "System Config",
        roles:[],
        icon: <RestartAltIcon/>,
        content: <AdminAccessMode />
      },
      {
        subtitle: "Image Utility",
        roles:['vp_admin','vs_admin'],
        icon: <ImageIcon/>,
        content: <ImageUtility />
      },
      {
        subtitle: "DEX Requeue",
        roles:[],
        icon: <CloudSyncIcon/>,
        content: <DEXRequeue />
      }
    ]
  },
  {
    title: "Batch",
    roles:['batch_monitor'],
    defaultExpanded:false,
    subtabs:[
      {
        subtitle: "Job Status",
        roles:[],
        icon:<Traffic/>,
        content: <BatchMonJobStatus />,
      },
      {
        subtitle: "Job History",
        roles:[],
        icon:<History/>,
        content: <BatchMonJobHistory />,
      },
    ]
  },
  {
    title: "Security",
    roles:['security_admin'],
    defaultExpanded:false,
    subtabs:[
      {
        subtitle: "Roles",
        roles:[],
        icon:<Security/>,
        content: <SecAdminRoles />,
      },
      {
        subtitle: "Mapping",
        roles:[],
        icon:<SupervisedUserCircle/>,
        content: <SecAdminRoleMap />,
      },
      {
        subtitle: "Sales Office",
        roles:[],
        icon:<EmojiTransportation/>,
        content: <SecAdminSalesOff />,
      },
      {
        subtitle: "Logins",
        roles:[],
        icon:<Book/>,
        content: <SecAdminLatestLogin />,
      },
      {
        subtitle: "Audit",
        roles:[],
        icon:<VerifiedUser/>,
        content: <SecAdminAudit />,
      },
    ]
  },
  {
    title: "Common",
    roles:['vp_admin','vs_admin'],
    defaultExpanded:false,
    subtabs:[
      {
        subtitle: "Access Config",
        roles:[],
        icon: <Security/>,
        content: <AdminAccessConfig />,
      },
	  {
        subtitle: "Warehouse",
        roles:[],
        icon: <Warehouse/>,
        content: <WarehouseLocation />,
      },
      {
        subtitle: "Email DL",
        roles:[],
        icon: <Email/>,
        content: <AdminEmailDL />,
      },
      {
        subtitle: "Bulk Bank",
        roles:['vp_admin_bulk','vs_admin_bulk'],
        icon: <Apartment/>,
        content: <AdminBanks />,
      },
      {
        subtitle: "Bulk Note",
        roles:['vp_admin_bulk','vs_admin_bulk'],
        icon: <NoteAdd/>,
        content: <AdminBulkNotes />
      },
      {
        subtitle: "Suspension",
        roles:['vp_admin_bulk','vs_admin_bulk'],
        icon: <TimerOff/>,
        content: <AdminBulkSuspensions />
      },
      {
        subtitle: "Bulk Sales Days",
        roles:['vp_admin_bulk','vs_admin_bulk'],
        icon: <EventRepeatIcon />,
        content: <AdminBulkSales />
      },
      {
        subtitle: "Set Priority",
        roles:[],
        icon: <GradeIcon/>,
        content: <AdminSetPriority />
      },
      {
        subtitle: "Route Management",
        roles:[],
        icon: <RouteIcon/>,
        content: <AdminRouteManagement />
      },
      {
        subtitle: "Logins",
        roles:[],
        icon:<Book/>,
        content: <ComAdminLatestLogin />,
      },
      {
        subtitle: "Contracts",
        roles:[],
        icon: <DescriptionIcon/>,
        content: <AdminContracts />,
      }
    ]
  },
  {
    title: "Vend Prime",
    roles:['vp_admin'],
    subtabs:[
      {
        subtitle: "System",
        roles:[],
        icon:<Settings/>,
        content: <AdminSystemConfig vp={true} />,
      },
      {
        subtitle: "Configurations",
        roles:[],
        icon:<Schema/>,
        content: <Configurations />,
      },
      {
        subtitle: "Mapping",
        roles:[],
        icon:<ViewQuilt/>,
        content: <AdminEquipmentMapping />,
      },
      {
        subtitle: "Capacity",
        roles:[],
        icon:<Queue/>,
        content: <AdminEquipmentCapacity />,
      },
      {
        subtitle: "Missing",
        roles:[],
        icon:<ContactSupport />,
        content: <AdminEquipmentMissing />,
      },
     /*commente as its moved to another screen  need to delete coe later {
        subtitle: "Optimization",
        roles:[],
        icon:<Tune/>,
        content: <AdminOptimization />,
      },*/
      {
        subtitle: "Strategic",
        roles:[],
        icon:<Star/>,
        content: <AdminMaterialStrategic />,
      },
      {
        subtitle: "Replacement",
        roles:[],
        icon:<FindReplace/>,
        content: <AdminMaterialReplacement />,
      },
      {
        subtitle: "Map",
        roles:[],
        icon:<Public/>,
        content: <AdminMaps />,
      },
      {
        subtitle: "Bulk Brandflow",
        roles:[],
        icon:<ViewComfy/>,
        content: <AdminBulkBrandFlow />
      }
    ]
  },
  {
    title: "Vend Smart",
    roles:['vs_admin'],
    subtabs:[
      {
        subtitle: "System",
        roles:[],
        icon:<Settings/>,
        content: <AdminSystemConfig vs={true} />,
      },
      {
        subtitle: "Operation",
        roles:[],
        icon:<DateRange/>,
        content: <AdminSalesOfficeOperation />,
      },
      {
        subtitle: "Buffer Config",
        roles:[],
        icon:<PercentIcon/>,
        content: <AdminBufferConfig />,
      },
      {
        subtitle: "Seasonality",
        roles:[],
        icon:<Settings/>,
        content: <AdminSeasonalityConfig />,
      },
    ]
  },
];


interface AdminRouteParams {
  tab: string;
  subtab: string;
}
export default function AdminPage() {
  const routeParams = useParams<AdminRouteParams>();
  const classes = useStyles();

  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");

  const history = useHistory();
  
  const landing = (
    <div  style={{width:"100%"}}>
      <Grid container spacing={1} className={classes.primary} style={{width:"100%"}}>
        <Grid item xs={4}>
          <img alt="" className={classes.image} src={getPublicImagePath(`/admin_icon.png`)}></img>
        </Grid>
        <Grid item xs={8}>
          <Typography variant="h3" className={classes.paragraph}>
            Admin / Configuration / Monitor
          </Typography>
          <Typography
            variant="subtitle1"
            className={classes.paragraphAct}
            paragraph
          >
            Maintain the controlling data for VendPrime and VendSmart. You can
            modify equipment mappings, optimization parameters, email
            distribution lists, etc. Some bulk changes can be done by
            downloading/uploading a csv file.
          </Typography>
          <Typography
            variant="subtitle1"
            className={classes.paragraphAct}
            paragraph
          >
            Security admin will allow you to see and change IDM role mappings to
            VendPrime / VendSmart roles. You can also maintain the user to Sales
            Office assignments. Security log displays when users logged into the
            system, and what IDM roles they had assigned at the time they logged
            in.
          </Typography>
          <Typography
            variant="subtitle1"
            className={classes.paragraphAct}
            paragraph
          >
            Batch admin just gives high level visibility to batch jobs running,
            or a large backlog of data being proccessed by batch.
          </Typography>
        </Grid>
      </Grid>
    </div>
    );
    
    const [tabState, setTabState] = React.useState('');
    const [curContent, setCurContent] = React.useState<JSX.Element>(landing);

  useEffect(() => {
    if(!tabState || tabState === ''){
      let tab = routeParams.tab
      if(tab){
        let nTab = navigation.find(n=>n.title.toLowerCase() === tab.toLowerCase())
        let nIdx = navigation.findIndex(n=>n.title.toLowerCase() === tab.toLowerCase())
        let subtab = routeParams.subtab
        if(nTab && subtab){
          let nSubtab = nTab.subtabs.find(s=>s.subtitle.toLowerCase() === subtab.toLowerCase())
          let tIdx = nTab.subtabs.findIndex(s=>s.subtitle.toLowerCase() === subtab.toLowerCase())
          if(nSubtab){
            setTabState(`nav-${nIdx}-${tIdx}`); 
            setCurContent(nSubtab.content);
          }
        }
      }
    }

  }, [tabState, curContent, routeParams.tab, routeParams.subtab]);


  return (
    <ResponsiveDrawer
      title={`${toFistCharUpperCase((routeParams.tab || ""))} Admin: ${toFistCharUpperCase((routeParams.subtab || ""))}`}
    >
      <Drawer
        className={classes.drawer}
        variant="permanent"
        hideBackdrop={true}
        open={true}
        classes={{
          paper: classes.drawerPaper,
        }}
        style={{zIndex:2}}
      >
        <div className={classes.drawerContainer} >
          {
            navigation.map((nav, nIdx) => {
              if( nav.roles.length === 0 || checkForRoles(clientId, salesOrg, nav.roles)){
                return(
                  <Accordion key={`a-${nIdx}`}  className={classes.accordion} defaultExpanded={nav.defaultExpanded}>
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      key={`as-${nIdx}`} 
                    >
                      <Typography>{nav.title}</Typography>
                    </AccordionSummary>
                    <AccordionDetails key={`ad-${nIdx}`} >
                      <List key={`nav-${nIdx}`} >
                      {nav.subtabs.map((tab,tIdx) => {
                        if( tab.roles.length === 0 || checkForRoles(clientId, salesOrg, tab.roles)){
                          return(
                            <ListItem button className={classes.drawerNavLink}
                              selected={`nav-${nIdx}-${tIdx}` === tabState}
                              key={`nav-${nIdx}-${tIdx}`} 
                              onClick={() => {
                                setTabState(`nav-${nIdx}-${tIdx}`); 
                                setCurContent(tab.content);
                                history.push(`/admin/${nav.title.toLowerCase()}/${tab.subtitle.toLowerCase()}`);
                              }}
                            >
                              <ListItemIcon key={`nav-${nIdx}-${tIdx}-ico`} style={{margin:0, padding:0}}>{tab.icon}</ListItemIcon>
                              <ListItemText key={`nav-${nIdx}-${tIdx}-txt`} primary={tab.subtitle} />
                            </ListItem>
                          )}
                        return (<div></div>);
                      }
                      )}
                      </List>
                    </AccordionDetails>
                  </Accordion>
                )
              }
              return (<div></div>);
            }
          )
        }
        </div>
      </Drawer>
      <main className={classes.content}>
        {(curContent)?curContent:<div></div>}
      </main>
    </ResponsiveDrawer>
  );
}
